// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

// ACCOUNT DAY BOOK ACTION TYPES
const AccountDayBookReportActionTypes = {
	FETCH_DAY_BOOK_REPORT_START: 'fetch_day_book_report_start',
	FETCH_DAY_BOOK_REPORT_SUCCESS: 'fetch_day_book_report_success',
	FETCH_DAY_BOOK_REPORT_FAILURE: 'fetch_day_book_report_failure',
	FETCH_DAY_BOOK_REPORT_RESPONSE_RESET: 'fetch_day_book_report_response_reset',
	FETCH_DAY_BOOK_REPORT_RESPONSE_CHANGED: 'fetch_day_book_report_response_changed',
};
export default AccountDayBookReportActionTypes;
